import { Box, Button, Typography, styled } from '@mui/material';

export const FormContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  // gap: theme.spacing(1),
  width: '100%',
  // padding: '7px'
  // paddingBottom: theme.spacing(4),
}));

export const SectionCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '1rem 1rem 0rem 1rem',
  boxShadow: '0 1px 5px 2px rgba(0, 0, 0, 0.10)',
  border: '1px solid #F0F0F0',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  height: 'fit-content',
  position: 'relative',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  fontStyle: 'normal',
  color: '#504E5A',
  marginBottom: theme.spacing(0.5),
}));

export const AddBrandButton = styled(Button)<{ themecolor?: string }>(({ themecolor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.25rem',
  backgroundColor: themecolor || '#7f52d5',
  textTransform: 'none',
  fontWeight: 400,
  fontStyle: 'normal',
  height: '1.9rem',
  width: '9rem',
  padding: '0.375rem 1rem;',
  lineHeight: 1,
  borderRadius: '0.625rem',
  marginBottom: '1rem',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: themecolor || '#7f52d5',
    opacity: 0.9,
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      fontSize: '1rem',
      display: 'block',
    },
  },
}));

export const RemoveBrandButton = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.25rem',
  backgroundColor: '#d6382c',
  textTransform: 'none',
  fontWeight: 400,
  fontStyle: 'normal',
  height: '1.9rem',
  width: '9rem',
  padding: '0.375rem 1rem;',
  lineHeight: 1,
  borderRadius: '0.625rem',
  marginBottom: '1rem',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#e24237',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      fontSize: '1rem',
      display: 'block',
    },
  },
});
